import * as Yup from 'yup';

export const MeetSchema = Yup.object({
  title: Yup.string().required('Campo requerido'),
  description: Yup.string(),
  summary: Yup.string().required('Campo requerido'),
  date: Yup.string().required('Campo requerido'),
});
